<template>
  <div data-component-group="filter-forms" data-component="package">
    <FiltersForm
      has-phone-sheet
      :applied-filters="appliedFilters"
      :on-clear-filter="clearFilter"
      :has-filters="hasFilters"
      :is-global-country-filter="false"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <template v-slot:phone-actions>
        <slot name="phone-actions" />
      </template>

      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import filterUrlSync from '@/mixins/filterUrlSync';
  import filterChips from '@/mixins/filterChips';
  import { escapeSearch } from '@/utils'

  // TODO: Translate component

  export default {
    mixins: [filterUrlSync, filterChips],
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
        ],
        search: null,
      };
    },
    computed: {
      filterChipFields() {
        return [
          { model: 'search', label: 'Search' },
        ];
      },
      hasFilters() {
        const { search } = this;

        return !!search;
      },
    },
    methods: {
      onFilter() {
        const { search } = this;
        const formattedSearch = escapeSearch(search);

        this.syncFiltersToUrl();
        this.rememberAppliedFilters();


        this.$emit('filter', {
          search: formattedSearch,
        });
      },
      onClearFilters() {
        this.search = null;

        this.clearFiltersUrl();
        this.forgetAppliedFilters();


        this.$emit('clearFilters');
      },
    },
  };
</script>
